<template>
    <div>
        <el-form
                ref="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm"
                :model="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm"
                label-width="80px"
                :label-position="'center'">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                            v-if="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.school_status"
                            label="学校">
                        <el-select
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.school_id"
                                filterable remote
                                @change="handleSearchSchool"
                                placeholder="请选择学校"
                                style="width: 180px!important;">
                            <el-option
                                    v-for="item in $parentInfo.initInformation.schools"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <el-button @click="handleSchoolInputChange()" size="mini" style="width: 40px;height: 28px">+</el-button>
                    </el-form-item>
                    <el-form-item v-else label="学校">
                        <el-input style="width:180px"
                                  v-model="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.defined_school"
                                  placeholder="输入学校"
                        ></el-input>
                        <el-button @click="handleSchoolInputChange()" size="mini" style="width: 40px;height: 28px">-</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="年级">
                        <el-select
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.grade_id"
                                align="right"
                                placeholder="在读年级"
                                style="width: 180px!important;">
                            <el-option
                                    v-for="item in $parentInfo.initInformation.grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="班级">
                        <el-select
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.schoolClass_id"
                                align="right"
                                placeholder="在读班级"
                                style="width: 180px!important;">
                            <el-option
                                    v-for="item in $parentInfo.initInformation.schoolClasses"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="入学日期">
                        <el-date-picker
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.school_year"
                                type="date"
                                placeholder="选择日期"
                                style="width: 180px!important;">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="毕业日期">
                        <el-date-picker
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.graduated_at"
                                type="date"
                                placeholder="选择日期"
                                style="width: 180px!important;">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="text-right">
            <el-button type="primary" @click="handleStoreEducationalExperiences()"
                       :loading="$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.button_loading">
                保存
            </el-button>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Dialog_StudentAddEducationalExperiences',
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm =
                {
                    school_id: '',
                    school_year: '',
                    graduated_at: '',
                    defined_school: '',
                    schoolClass_id: '',
                    grade_id: '',
                }
        },
        methods: {
            handleSchoolInputChange() {
                if (this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.school_status === true) {
                    this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.school_status = false;
                } else {
                    this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.school_status = true;
                }
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type': 'searchSchool',
                    'schoolKeyName': query,
                });
            },
            handleStoreEducationalExperiences() {
                this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.button_loading = true;
                this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.graduated_at = this.$moment(this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.graduated_at).format('YYYY-MM-DD');
                this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.school_year = this.$moment(this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.school_year).format('YYYY-MM-DD');
                this.$wApi.send(this.$parentInfo.path, 'storeEducationExperiences', {
                    'student_id': this.$parentInfo.student_id,
                    'defined_school': this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.defined_school != null ? this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.defined_school : null,
                    'school_id': this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.school_id,
                    'schoolClass_id': this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.schoolClass_id,
                    'graduated_at': this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.graduated_at,
                    'school_year': this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.school_year,
                    'grade_id': this.$parentInfo.studentEducationalExperiences.dialog_StudentAddEducationalExperiences.educationalExperiencesForm.grade_id,
                    'school_type': '',

                });
            },

        }
    }
</script>

<style scoped>
    .card-body {
        height: calc(100vh - 125px);
    }

    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }

    .el-select {
        width: 100% !important;
    }
</style>
